import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { ModalBase } from "../components/ModalBase";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import Button from "@mui/material/Button";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  isEmail,
  isInRange,
  isNumber,
  isPhoneNumber,
  isRequired,
  isUrl,
} from "../common/inputValidator";
import { FxWindow } from "../../fxms/windows/FxWindows";

const CHK_METHD_CD = [{ cd: "MANUAL" }, { cd: "ZSCORE" }];

const MON_TARGET = [
  {
    cd: "IP",
    chks: ["ping", "latency", "cpu", "disk", "memory"],
  },
  {
    cd: "URL",
    chks: ["http", "latency"],
  },
  {
    cd: "DB",
    chks: ["http", "dataCnt"],
  },
];

const CONTACT = [
  {
    cd: "SMS",
    method: "휴대전화",
    placeholder: "010-1234-5678",
  },
  {
    cd: "EMAIL",
    method: "이메일",
    placeholder: "nickname@example.com",
  },
];

export const UI_5_5_CU = (props) => {
  const { open, closeModal, isEdit, initialData } = props;
  const [inputBaseSettings, setInputBaseSettings] = useState(
    !isEdit && {
      monTargetNm: "",
      intervalMin: "",
      chkClCd: MON_TARGET[0].cd,
      monAddr: "",
      ping: true,
      http: false,
      latency: true,
      dataCnt: false,
      cpu: true,
      disk: true,
      memory: true,
      userId: "",
      password: "",
      port: "",
      useYn: true,
    }
  );
  const [inputThrSettings, setInputThrSettings] = useState(
    !isEdit && {
      latency: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      cpu: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      disk: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      memory: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      db: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
    }
  );
  const [inputRecpSettings, setInputRecpSettings] = useState(!isEdit && []);
  const [showPassword, setShowPassword] = React.useState(false);

  // 수정 모달인 경우 초기값 가져오기
  useEffect(() => {
    if (open && isEdit && initialData.monTargetNo) {
      getSelectDetail();
    } else {
      init();
    }
  }, [open, isEdit]);

  const init = () => {
    setInputBaseSettings({
      monTargetNm: "",
      intervalMin: "",
      chkClCd: MON_TARGET[0].cd,
      monAddr: "",
      ping: true,
      http: false,
      latency: true,
      dataCnt: false,
      cpu: true,
      disk: true,
      memory: true,
      userId: "",
      password: "",
      port: "",
      useYn: true,
    });
    setInputThrSettings({
      latency: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      cpu: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      disk: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      memory: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
      db: {
        chkMethdCd: CHK_METHD_CD[0].cd,
        zScoreVal: "",
        intervalMin: "",
        dataCnt: 0,
      },
    });
    setInputRecpSettings([]);
  };

  // 수정 모달인 경우
  const getSelectDetail = async () => {
    const monTargetNo = initialData.monTargetNo;
    if (!monTargetNo) return;

    try {
      const response = await axios.get(`/api/vup/select_5_5/${monTargetNo}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const result = response?.data;
      const base = result.target;
      const thr = result.thresholds;
      const recp = result.recipients;
      setInputBaseSettings({
        monTargetNm: base.monTargetNm,
        intervalMin: base.chkIntervalMin,
        chkClCd: MON_TARGET[Number(base.chkClNm) - 1].cd,
        monAddr: base.ipAddrVal ? base.ipAddrVal : base.urlVal,
        ping: base.usePingChkYn === "Y" ? true : false,
        http: base.useHttpChkYn === "Y" ? true : false,
        latency: base.useLatencyChkYn === "Y" ? true : false,
        dataCnt: base.useDataCntChkYn === "Y" ? true : false,
        cpu: base.useCpuChkYn === "Y" ? true : false,
        disk: base.useDiskChkYn === "Y" ? true : false,
        memory: base.useMemoryChkYn === "Y" ? true : false,
        userId: base.userId,
        password: base.password,
        port: base.port,
        useYn: base.useYn === "Y" ? true : false,
      });

      const thrResult = {
        latency: {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        },
        cpu: {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        },
        disk: {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        },
        memory: {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        },
        db: {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        },
      };
      thr.forEach((item) => {
        let key = item.chkItemNm?.toLowerCase();
        if (key === "data") {
          key = "db";
        }
        if (key) {
          const thrMethd = CHK_METHD_CD[Number(item.chkMethdCd) - 1].cd;
          thrResult[key] = {
            chkMethdCd: thrMethd ? thrMethd : CHK_METHD_CD[0].cd,
            zScoreVal: item.zScoreVal ? item.zScoreVal : "",
            intervalMin: item.manualThrVal ? item.manualThrVal : "",
            dataCnt:
              item.chkItemNm === "DATA" && item.manualThrVal
                ? item.manualThrVal
                : 0,
          };
        }
      });
      setInputThrSettings((prev) => {
        return { ...prev, ...thrResult };
      });

      const recpResult = [];
      recp.forEach((item) => {
        recpResult.push({
          index: item.recvNo,
          recvClCd: CONTACT[Number(item.recvClCd) - 1].cd,
          recvContact: item.recvTelNo ? item.recvTelNo : item.recvEmail,
          recvNm: item.recvNm,
        });
      });
      setInputRecpSettings(recpResult);
    } catch (e) {
      console.log("UI_5_5_CU fetchData error", e);
    }
  };

  const handleClose = () => {
    closeModal();
  };

  const handleOnChangeBaseValue = (id, value) => {
    let newData = { ...inputBaseSettings };
    if (value !== undefined && value !== null) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputBaseSettings(newData);
  };

  const handleOnChangeThrValue = (id, value) => {
    let newData = { ...inputThrSettings };
    const [category, field] = id.split(".");

    if (category && field) {
      if (!newData[category]) {
        newData[category] = {
          chkMethdCd: CHK_METHD_CD[0].cd,
          zScoreVal: "",
          intervalMin: "",
          dataCnt: 0,
        };
      }
      newData[category][field] = value;
    }

    setInputThrSettings(newData);
  };

  const handleOnChangeRecpValue = (id, value, index) => {
    setInputRecpSettings((prevSettings) =>
      prevSettings.map((item) => {
        if (item.index === index) {
          return { ...item, [id]: value };
        }
        return item;
      })
    );
  };

  const handleOnClickRecpDelete = (index) => {
    setInputRecpSettings(
      inputRecpSettings.filter((item) => item.index !== index)
    );
  };

  const handleOnClickRecpAdd = () => {
    setInputRecpSettings([
      ...inputRecpSettings,
      {
        index: uuidv4(),
        recvNm: "",
        recvClCd: CONTACT[0].cd,
        recvContact: "",
      },
    ]);
  };

  // 감시대상 유형에 따라 체크박스 변경
  const isCheckboxEnabled = (checkboxName) => {
    const target = MON_TARGET.find((t) => t.cd === inputBaseSettings.chkClCd);
    return target ? target.chks.includes(checkboxName) : false;
  };

  const handleOnClickSubmit = async () => {
    const errorMessage = isValidate();
    if (errorMessage) {
      FxWindow.alert(errorMessage, true);
      return;
    }

    if (isEdit) {
      try {
        const response = await axios({
          method: "PUT",
          url: "api/vup/update_5_5",
          headers: {
            "Content-Type": "Application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            target: {
              ...inputBaseSettings,
              monTargetNo: initialData?.monTargetNo,
            },
            threshold: inputThrSettings,
            recipient: inputRecpSettings,
          },
        }).then((result) => {
          console.log("UI_5_5_CU update 성공", result);
          closeModal();
        });
      } catch (e) {
        console.log("UI_5_5_CU update fetchData error", e);
      }
    }
    if (!isEdit) {
      try {
        const response = await axios({
          method: "POST",
          url: "api/vup/add_5_5",
          headers: {
            "Content-Type": "Application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            target: inputBaseSettings,
            threshold: inputThrSettings,
            recipient: inputRecpSettings,
          },
        }).then((result) => {
          console.log("UI_5_5_CU 성공", result);
          closeModal();
        });
      } catch (e) {
        console.log("UI_5_5_CU fetchData error", e);
      }
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const isValidate = () => {
    let errorMessage = "";
    errorMessage = isRequired(inputBaseSettings.monTargetNm);
    if (errorMessage) {
      return "서버명 " + errorMessage;
    }
    errorMessage = isInRange(inputBaseSettings.intervalMin, 1, 60 * 24 * 7); // 7일
    if (errorMessage) {
      return "주기(분)에 " + errorMessage;
    }
    if (inputBaseSettings.chkClCd === "IP") {
      errorMessage = isRequired(inputBaseSettings.monAddr);
      if (errorMessage) {
        return "주소 " + errorMessage;
      }
    } else if (
      inputBaseSettings.chkClCd === "URL" ||
      inputBaseSettings.chkClCd === "DB"
    ) {
      errorMessage = isUrl(inputBaseSettings.monAddr);
      if (errorMessage) {
        return "주소 값으로 " + errorMessage;
      }
    }
    errorMessage = isNumber(inputBaseSettings.port);
    if (errorMessage) {
      return "port 값으로 " + errorMessage;
    }
    errorMessage = isRequired(inputBaseSettings.userId);
    if (errorMessage) {
      return "userId " + errorMessage;
    }
    errorMessage = isRequired(inputBaseSettings.password);
    if (errorMessage) {
      return "password " + errorMessage;
    }
    const selectedItems = [
      inputBaseSettings.ping,
      inputBaseSettings.http,
      inputBaseSettings.latency,
      inputBaseSettings.dataCnt,
      inputBaseSettings.cpu,
      inputBaseSettings.disk,
      inputBaseSettings.memory,
    ].filter(Boolean).length;
    if (selectedItems < 2) {
      return "점검 항목을 선택해주세요.";
    }
    if (inputBaseSettings.latency) {
      if (inputThrSettings.latency.chkMethdCd === CHK_METHD_CD[0].cd) {
        errorMessage = isInRange(
          inputThrSettings.latency.intervalMin,
          0,
          10_000_000
        );
      } else if (inputThrSettings.latency.chkMethdCd === CHK_METHD_CD[1].cd) {
        errorMessage = isInRange(
          inputThrSettings.latency.zScoreVal,
          0,
          10_000_000
        );
      }
      if (errorMessage) {
        return "Latency 값으로 " + errorMessage;
      }
    }
    if (inputBaseSettings.cpu) {
      if (inputThrSettings.cpu.chkMethdCd === CHK_METHD_CD[0].cd) {
        errorMessage = isInRange(
          inputThrSettings.cpu.intervalMin,
          0,
          10_000_000
        );
      } else if (inputThrSettings.cpu.chkMethdCd === CHK_METHD_CD[1].cd) {
        errorMessage = isInRange(inputThrSettings.cpu.zScoreVal, 0, 10_000_000);
      }
      if (errorMessage) {
        return "Cpu 값으로 " + errorMessage;
      }
    }
    if (inputBaseSettings.disk) {
      if (inputThrSettings.disk.chkMethdCd === CHK_METHD_CD[0].cd) {
        errorMessage = isInRange(
          inputThrSettings.disk.intervalMin,
          0,
          10_000_000
        );
      } else if (inputThrSettings.disk.chkMethdCd === CHK_METHD_CD[1].cd) {
        errorMessage = isInRange(
          inputThrSettings.disk.zScoreVal,
          0,
          10_000_000
        );
      }
      if (errorMessage) {
        return "Disk 값으로 " + errorMessage;
      }
    }
    if (inputBaseSettings.memory) {
      if (inputThrSettings.memory.chkMethdCd === CHK_METHD_CD[0].cd) {
        errorMessage = isInRange(
          inputThrSettings.memory.intervalMin,
          0,
          10_000_000
        );
      } else if (inputThrSettings.memory.chkMethdCd === CHK_METHD_CD[1].cd) {
        errorMessage = isInRange(
          inputThrSettings.memory.zScoreVal,
          0,
          10_000_000
        );
      }
      if (errorMessage) {
        return "Memory 값으로 " + errorMessage;
      }
    }
    if (inputBaseSettings.dataCnt) {
      if (inputThrSettings.db.chkMethdCd === CHK_METHD_CD[0].cd) {
        errorMessage = isInRange(inputThrSettings.db.dataCnt, 0, 9_999_999_999);
      } else if (inputThrSettings.db.chkMethdCd === CHK_METHD_CD[1].cd) {
        errorMessage = isInRange(inputThrSettings.db.zScoreVal, 0, 999_999_999);
      }
      if (errorMessage) {
        return "수집건수 값으로 " + errorMessage;
      }
    }
    if (inputRecpSettings && inputRecpSettings.length > 0) {
      for (let i = 0; i < inputRecpSettings.length; i++) {
        let recp = inputRecpSettings[i];
        errorMessage = isRequired(recp.recvNm);
        if (errorMessage) {
          return "수신자 이름 " + errorMessage;
        }
        if (recp.recvClCd === CONTACT[0].cd) {
          errorMessage = isPhoneNumber(recp.recvContact);
        } else if (recp.recvClCd === CONTACT[1].cd) {
          errorMessage = isEmail(recp.recvContact);
        }
        if (errorMessage) {
          return errorMessage;
        }
      }
    }
    return null;
  };

  return (
    <>
      <ModalBase
        open={open}
        closeModal={handleClose}
        title={`감시대상 ${isEdit ? "수정" : "추가"}`}
      >
        <div style={{ height: "100%", overflow: "hidden" }}>
          <form>
            <div className="FxDataEdit">
              <section className="tableTitle">기본 설정</section>
              <table className="table">
                <colgroup>
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "300px" }} />
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "300px" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <FxLabelBase>서버명</FxLabelBase>
                    </th>
                    <td>
                      <FxTextFieldBase
                        name="monTargetNm"
                        onChangeValue={handleOnChangeBaseValue}
                        selectedData={inputBaseSettings}
                        disabled={false}
                      />
                    </td>
                    <th>
                      <FxLabelBase>주기(분)</FxLabelBase>
                    </th>
                    <td>
                      <input
                        id="intervalMin"
                        className="FxTextField"
                        type="number"
                        value={inputBaseSettings.intervalMin}
                        disabled={false}
                        onChange={(event) =>
                          handleOnChangeBaseValue(
                            event.target.id,
                            event.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FxLabelBase>감시대상</FxLabelBase>
                    </th>
                    <td>
                      <table>
                        <colgroup>
                          <col style={{ width: "200px" }} />
                          <col style={{ width: "300px" }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                유형
                              </p>
                            </th>
                            <td>
                              <select
                                className="FxSelectSearch"
                                style={{ width: "100%" }}
                                value={inputBaseSettings.chkClCd}
                                name="monTarget"
                                onChange={(e) => {
                                  const selectedType = e.target.value;
                                  const target = MON_TARGET.find(
                                    (t) => t.cd === selectedType
                                  );
                                  const newSettings = {
                                    ...inputBaseSettings,
                                    chkClCd: selectedType,
                                    // 모든 체크박스를 false로 초기화
                                    ping: false,
                                    http: false,
                                    latency: false,
                                    dataCnt: false,
                                    cpu: false,
                                    disk: false,
                                    memory: false,
                                  };
                                  // 선택된 타입의 체크박스들을 true로 설정
                                  if (target) {
                                    target.chks.forEach((chk) => {
                                      newSettings[chk] = true;
                                    });
                                  }
                                  const newThrSettings = {
                                    latency: {
                                      chkMethdCd: CHK_METHD_CD[0].cd,
                                      zScoreVal: "",
                                      intervalMin: "",
                                      dataCnt: 0,
                                    },
                                    cpu: {
                                      chkMethdCd: CHK_METHD_CD[0].cd,
                                      zScoreVal: "",
                                      intervalMin: "",
                                      dataCnt: 0,
                                    },
                                    disk: {
                                      chkMethdCd: CHK_METHD_CD[0].cd,
                                      zScoreVal: "",
                                      intervalMin: "",
                                      dataCnt: 0,
                                    },
                                    memory: {
                                      chkMethdCd: CHK_METHD_CD[0].cd,
                                      zScoreVal: "",
                                      intervalMin: "",
                                      dataCnt: 0,
                                    },
                                    db: {
                                      chkMethdCd: CHK_METHD_CD[0].cd,
                                      zScoreVal: "",
                                      intervalMin: "",
                                      dataCnt: 0,
                                    },
                                  };
                                  setInputBaseSettings(newSettings);
                                  setInputThrSettings(newThrSettings);
                                }}
                              >
                                {MON_TARGET.map((target) => (
                                  <option key={target.cd} value={target.cd}>
                                    {target.cd}
                                  </option>
                                ))}
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                주소
                              </p>
                            </th>
                            <FxTextFieldBase
                              name="monAddr"
                              defaultValue={inputBaseSettings.monAddr}
                              onChangeValue={handleOnChangeBaseValue}
                              selectedData={inputBaseSettings}
                              disabled={false}
                              placeholder="주소"
                            />
                          </tr>
                          <tr>
                            <th>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                port
                              </p>
                            </th>
                            <FxTextFieldBase
                              name="port"
                              defaultValue={inputBaseSettings.port}
                              onChangeValue={handleOnChangeBaseValue}
                              selectedData={inputBaseSettings}
                              disabled={false}
                              placeholder=""
                            />
                          </tr>
                          <tr>
                            <th>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                userId
                              </p>
                            </th>
                            <FxTextFieldBase
                              name="userId"
                              defaultValue={inputBaseSettings.userId}
                              onChangeValue={handleOnChangeBaseValue}
                              selectedData={inputBaseSettings}
                              disabled={false}
                              placeholder="userId"
                            />
                          </tr>
                          <tr>
                            <th>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                password
                              </p>
                            </th>
                            <td>
                              <div style={{ display: "flex" }}>
                                <input
                                  id="password"
                                  className={"FxTextField"}
                                  type={showPassword ? "text" : "password"}
                                  placeholder=""
                                  value={inputBaseSettings.password}
                                  disabled={false}
                                  onChange={(event) =>
                                    handleOnChangeBaseValue(
                                      event.target.id,
                                      event.target.value
                                    )
                                  }
                                />
                                <IconButton
                                  sx={{ color: "#979797" }}
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  onMouseUp={handleMouseUpPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <th>
                      <FxLabelBase>점검 항목</FxLabelBase>
                    </th>
                    <td>
                      <Box>
                        <FormControl
                          required
                          component="fieldset"
                          variant="standard"
                        >
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.ping}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="ping"
                                  disabled={true}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("ping")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Ping
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.http}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="http"
                                  disabled={true}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("http")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Http
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.latency}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="latency"
                                  disabled={!isCheckboxEnabled("latency")}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("latency")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Latency
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.dataCnt}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="dataCnt"
                                  disabled={!isCheckboxEnabled("dataCnt")}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("dataCnt")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  수집건수
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.cpu}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="cpu"
                                  disabled={!isCheckboxEnabled("cpu")}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("cpu")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Cpu
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.disk}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="disk"
                                  disabled={!isCheckboxEnabled("disk")}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("disk")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Disk
                                </span>
                              }
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "white",
                                    "&.Mui-disabled": {
                                      color: "gray",
                                    },
                                  }}
                                  checked={inputBaseSettings.memory}
                                  onChange={(e) => {
                                    handleOnChangeBaseValue(
                                      e.target.name,
                                      e.target.checked
                                    );
                                  }}
                                  name="memory"
                                  disabled={!isCheckboxEnabled("memory")}
                                />
                              }
                              label={
                                <span
                                  style={{
                                    color: !isCheckboxEnabled("memory")
                                      ? "gray"
                                      : "white",
                                  }}
                                >
                                  Memory
                                </span>
                              }
                            />
                          </FormGroup>
                        </FormControl>
                      </Box>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <FxLabelBase>사용 여부</FxLabelBase>
                    </th>
                    <td>
                      <FormControl
                        required
                        component="fieldset"
                        variant="standard"
                      >
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="on"
                          name="radio-buttons-group"
                          value={inputBaseSettings.useYn ? "on" : "off"}
                          onChange={(event) => {
                            handleOnChangeBaseValue(
                              "useYn",
                              event.target.value === "on"
                            );
                          }}
                          row
                        >
                          <FormControlLabel
                            value="off"
                            control={<Radio sx={{ color: "white" }} />}
                            label="off"
                          />
                          <FormControlLabel
                            value="on"
                            control={<Radio sx={{ color: "white" }} />}
                            label="on"
                          />
                        </RadioGroup>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
              </table>
              <section className="tableTitle" style={{ paddingTop: "12px" }}>
                임계치 설정
              </section>
              <table className="table">
                <colgroup>
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "200px" }} />
                  <col style={{ width: "100px" }} />
                  <col style={{ width: "200px" }} />
                </colgroup>
                <tbody>
                  {inputBaseSettings.chkClCd === "URL" &&
                  inputBaseSettings.latency ? (
                    <>
                      <tr>
                        <td colSpan="6">
                          <p
                            style={{
                              padding: "4px",
                              margin: "0px",
                              fontSize: "18px",
                            }}
                          >
                            Latency
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <FxLabelBase>판단 방식</FxLabelBase>
                        </th>
                        <td>
                          <select
                            className="FxSelectSearch"
                            name="latency.chkMethdCd"
                            value={inputThrSettings.latency.chkMethdCd}
                            onChange={(e) => {
                              handleOnChangeThrValue(
                                e.target.name,
                                e.target.value
                              );
                            }}
                          >
                            {CHK_METHD_CD.map((methd) => (
                              <option key={methd.cd} value={methd.cd}>
                                {methd.cd}
                              </option>
                            ))}
                          </select>
                        </td>
                        <th>
                          <FxLabelBase>Z값</FxLabelBase>
                        </th>
                        <td>
                          <FxTextFieldBase
                            name="latency.zScoreVal"
                            defaultValue={inputThrSettings.latency.zScoreVal}
                            onChangeValue={handleOnChangeThrValue}
                            selectedData={inputThrSettings.latency}
                            disabled={
                              inputThrSettings.latency.chkMethdCd !==
                              CHK_METHD_CD[1].cd
                            }
                          />
                        </td>
                        <th>
                          <FxLabelBase>수동 기준</FxLabelBase>
                        </th>
                        <td>
                          <FxTextFieldBase
                            name="latency.intervalMin"
                            defaultValue={inputThrSettings.latency.intervalMin}
                            onChangeValue={handleOnChangeThrValue}
                            selectedData={inputThrSettings.latency}
                            disabled={
                              inputThrSettings.latency.chkMethdCd !==
                              CHK_METHD_CD[0].cd
                            }
                          />
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr></tr>
                  )}

                  {inputBaseSettings.chkClCd === "IP" && (
                    <>
                      {inputBaseSettings.latency && (
                        <>
                          <tr>
                            <td colSpan="6">
                              <p
                                style={{
                                  padding: "4px",
                                  margin: "0px",
                                  fontSize: "18px",
                                }}
                              >
                                Latency
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <FxLabelBase>판단 방식</FxLabelBase>
                            </th>
                            <td>
                              <select
                                className="FxSelectSearch"
                                name="latency.chkMethdCd"
                                value={inputThrSettings.latency.chkMethdCd}
                                onChange={(e) => {
                                  handleOnChangeThrValue(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              >
                                {CHK_METHD_CD.map((methd) => (
                                  <option key={methd.cd} value={methd.cd}>
                                    {methd.cd}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <th>
                              <FxLabelBase>Z값</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="latency.zScoreVal"
                                defaultValue={
                                  inputThrSettings.latency.zScoreVal
                                }
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.latency}
                                disabled={
                                  inputThrSettings.latency.chkMethdCd !==
                                  CHK_METHD_CD[1].cd
                                }
                              />
                            </td>
                            <th>
                              <FxLabelBase>수동 기준</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="latency.intervalMin"
                                defaultValue={
                                  inputThrSettings.latency.intervalMin
                                }
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.latency}
                                disabled={
                                  inputThrSettings.latency.chkMethdCd !==
                                  CHK_METHD_CD[0].cd
                                }
                              />
                            </td>
                          </tr>
                        </>
                      )}
                      {inputBaseSettings.cpu && (
                        <>
                          <tr>
                            <td colSpan="6">
                              <p
                                style={{
                                  padding: "4px",
                                  margin: "0px",
                                  fontSize: "18px",
                                }}
                              >
                                Cpu
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <FxLabelBase>판단 방식</FxLabelBase>
                            </th>
                            <td>
                              <select
                                className="FxSelectSearch"
                                name="cpu.chkMethdCd"
                                value={inputThrSettings.cpu.chkMethdCd}
                                onChange={(e) => {
                                  handleOnChangeThrValue(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              >
                                {CHK_METHD_CD.map((methd) => (
                                  <option key={methd.cd} value={methd.cd}>
                                    {methd.cd}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <th>
                              <FxLabelBase>Z값</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="cpu.zScoreVal"
                                defaultValue={inputThrSettings.cpu.zScoreVal}
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.cpu}
                                disabled={
                                  inputThrSettings.cpu.chkMethdCd !==
                                  CHK_METHD_CD[1].cd
                                }
                              />
                            </td>
                            <th>
                              <FxLabelBase>수동 기준</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="cpu.intervalMin"
                                defaultValue={inputThrSettings.cpu.intervalMin}
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.cpu}
                                disabled={
                                  inputThrSettings.cpu.chkMethdCd !==
                                  CHK_METHD_CD[0].cd
                                }
                              />
                            </td>
                          </tr>
                        </>
                      )}
                      {inputBaseSettings.disk && (
                        <>
                          <tr>
                            <td colSpan="6">
                              <p
                                style={{
                                  padding: "4px",
                                  margin: "0px",
                                  fontSize: "18px",
                                }}
                              >
                                Disk
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <FxLabelBase>판단 방식</FxLabelBase>
                            </th>
                            <td>
                              <select
                                className="FxSelectSearch"
                                name="disk.chkMethdCd"
                                value={inputThrSettings.disk.chkMethdCd}
                                onChange={(e) => {
                                  handleOnChangeThrValue(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              >
                                {CHK_METHD_CD.map((methd) => (
                                  <option key={methd.cd} value={methd.cd}>
                                    {methd.cd}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <th>
                              <FxLabelBase>Z값</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="disk.zScoreVal"
                                defaultValue={inputThrSettings.disk.zScoreVal}
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.disk}
                                disabled={
                                  inputThrSettings.disk.chkMethdCd !==
                                  CHK_METHD_CD[1].cd
                                }
                              />
                            </td>
                            <th>
                              <FxLabelBase>수동 기준</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="disk.intervalMin"
                                defaultValue={inputThrSettings.disk.intervalMin}
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.disk}
                                disabled={
                                  inputThrSettings.disk.chkMethdCd !==
                                  CHK_METHD_CD[0].cd
                                }
                              />
                            </td>
                          </tr>
                        </>
                      )}
                      {inputBaseSettings.memory && (
                        <>
                          <tr>
                            <td colSpan="6">
                              <p
                                style={{
                                  padding: "4px",
                                  margin: "0px",
                                  fontSize: "18px",
                                }}
                              >
                                Memory
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              <FxLabelBase>판단 방식</FxLabelBase>
                            </th>
                            <td>
                              <select
                                className="FxSelectSearch"
                                name="memory.chkMethdCd"
                                value={inputThrSettings.memory.chkMethdCd}
                                onChange={(e) => {
                                  handleOnChangeThrValue(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              >
                                {CHK_METHD_CD.map((methd) => (
                                  <option key={methd.cd} value={methd.cd}>
                                    {methd.cd}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <th>
                              <FxLabelBase>Z값</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="memory.zScoreVal"
                                defaultValue={inputThrSettings.memory.zScoreVal}
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.memory}
                                disabled={
                                  inputThrSettings.memory.chkMethdCd !==
                                  CHK_METHD_CD[1].cd
                                }
                              />
                            </td>
                            <th>
                              <FxLabelBase>수동 기준</FxLabelBase>
                            </th>
                            <td>
                              <FxTextFieldBase
                                name="memory.intervalMin"
                                defaultValue={
                                  inputThrSettings.memory.intervalMin
                                }
                                onChangeValue={handleOnChangeThrValue}
                                selectedData={inputThrSettings.memory}
                                disabled={
                                  inputThrSettings.memory.chkMethdCd !==
                                  CHK_METHD_CD[0].cd
                                }
                              />
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )}
                  {inputBaseSettings.chkClCd === "DB" ? (
                    inputBaseSettings.dataCnt ? (
                      <>
                        <tr>
                          <td colSpan="6">
                            <p
                              style={{
                                padding: "4px",
                                margin: "0px",
                                fontSize: "18px",
                              }}
                            >
                              수집건수
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <FxLabelBase>판단 방식</FxLabelBase>
                          </th>
                          <td>
                            <select
                              className="FxSelectSearch"
                              name="db.chkMethdCd"
                              value={inputThrSettings.db.chkMethdCd}
                              onChange={(e) => {
                                handleOnChangeThrValue(
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            >
                              {CHK_METHD_CD.map((methd) => (
                                <option key={methd.cd} value={methd.cd}>
                                  {methd.cd}
                                </option>
                              ))}
                            </select>
                          </td>
                          <th>
                            <FxLabelBase>Z값</FxLabelBase>
                          </th>
                          <td>
                            <FxTextFieldBase
                              name="db.zScoreVal"
                              defaultValue={inputThrSettings.db.zScoreVal}
                              onChangeValue={handleOnChangeThrValue}
                              selectedData={inputThrSettings.db}
                              disabled={
                                inputThrSettings.db.chkMethdCd !==
                                CHK_METHD_CD[1].cd
                              }
                            />
                          </td>
                          <th>
                            <FxLabelBase>건수</FxLabelBase>
                          </th>
                          <td>
                            <FxTextFieldBase
                              name="db.dataCnt"
                              defaultValue={inputThrSettings.db.dataCnt}
                              onChangeValue={handleOnChangeThrValue}
                              selectedData={inputThrSettings.db}
                              disabled={
                                inputThrSettings.db.chkMethdCd !==
                                CHK_METHD_CD[0].cd
                              }
                            />
                          </td>
                        </tr>
                      </>
                    ) : (
                      <></>
                    )
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
              <section className="tableTitle" style={{ paddingTop: "12px" }}>
                수신자 설정
              </section>
              <table className="table">
                <colgroup>
                  <col style={{ width: "300px" }} />
                  <col style={{ width: "700px" }} />
                  <col style={{ width: "100px" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <FxLabelBase>이름</FxLabelBase>
                    </th>
                    <th>
                      <FxLabelBase>연락처</FxLabelBase>
                    </th>
                    <th>
                      <FxLabelBase></FxLabelBase>
                    </th>
                  </tr>
                  {inputRecpSettings.map((item) => (
                    <tr key={item.index}>
                      <td>
                        <FxTextFieldBase
                          name="recvNm"
                          defaultValue={item.recvNm}
                          onChangeValue={(id, value) => {
                            handleOnChangeRecpValue(id, value, item.index);
                          }}
                          selectedData={item}
                          disabled={false}
                        />
                      </td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <select
                            className="FxSelectSearch"
                            name="recvClCd"
                            value={item.recvClCd}
                            onChange={(e) => {
                              handleOnChangeRecpValue(
                                e.target.name,
                                e.target.value,
                                item.index
                              );
                            }}
                          >
                            {CONTACT.map((contact) => (
                              <option key={contact.cd} value={contact.cd}>
                                {contact.method}
                              </option>
                            ))}
                          </select>
                          <FxTextFieldBase
                            name="recvContact"
                            defaultValue={item.recvContact}
                            onChangeValue={(id, value) => {
                              handleOnChangeRecpValue(id, value, item.index);
                            }}
                            selectedData={item}
                            placeholder={
                              CONTACT.find(
                                (contact) => contact.cd === item.recvClCd
                              )?.placeholder
                            }
                            disabled={false}
                          />
                        </div>
                      </td>
                      <td>
                        <Button
                          id="delete"
                          className="button"
                          onClick={() => {
                            handleOnClickRecpDelete(item.index);
                          }}
                          variant="text"
                          size="small"
                        >
                          삭제
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Button
                id="delete"
                className="button"
                onClick={handleOnClickRecpAdd}
                sx={{ width: "100%" }}
                variant="text"
                size="small"
              >
                + 수신자 추가
              </Button>
            </div>
            <div className="FxCrudToolbar">
              <div className="FxFilterLeft"></div>
              <div className="FxFilterRight">
                <FxButtonBase
                  name="click"
                  onClick={handleOnClickSubmit}
                  text="저장"
                />
              </div>
            </div>
          </form>
        </div>
      </ModalBase>
    </>
  );
};
